import env from '../../config/env'
import { fetcher } from '../../utils/helpers'
import { TenantServicePath } from './TenantService'
import {
  UpdateOnboardingRequestBodyType,
  LoginRequestBodyType,
  OtpVerifyRequestBodyType,
  SignUpRequestBodyType,
  PolciyRequestBodyType,
  UpdateCurrentUserRequestBodyType,
  InviteUserRequestBodyType,
  UpdateCurrentTenantInvoiceRequestBodyType,
  SignUpV2RequestBodyType,
  AccountAvailabilityRequestBodyType,
  AuthenticationCredentialRequestBodyType,
  ForgotPasswordRequestBodyType,
  ConfirmSignupRequestBodyType,
  AuthenticationMethodRequestBodyType,
  ConfirmForgotPasswordRequestBody,
  ResendEmailConfirmationRequestBody,
} from './TenantService.types'

export const GetCurrentUserFetcher = (url: string) =>
  fetcher({
    baseURL: env.tenantUrl,
    method: 'GET',
    url,
  })

export const GetUsersFetcher = (url: string, query: string) =>
  fetcher({
    baseURL: env.tenantUrl,
    method: 'GET',
    url: `${url}${query}`,
  })

export const GetAccountAvailabilityFetcher = (data: AccountAvailabilityRequestBodyType) =>
  fetcher({
    baseURL: env.tenantUrl,
    data,
    method: 'GET',
    url: `${TenantServicePath.GetAccountAvailability}?authenticationMethod=${
      data?.authenticationMethod
    }&authenticationCredential=${encodeURIComponent?.(data.authenticationCredential || '')}`,
  })

export const PolicyFetcher = (data: PolciyRequestBodyType) =>
  fetcher({
    baseURL: env.tenantUrl,
    data,
    method: 'POST',
    url: TenantServicePath.Policy,
  })

export const LoginFetcher = (data: LoginRequestBodyType) => {
  return fetcher({
    baseURL: env.tenantUrl,
    data,
    method: 'POST',
    url: TenantServicePath.Login,
  })
}

export const OtpVerifyFetcher = (data: OtpVerifyRequestBodyType) => {
  return fetcher({
    baseURL: env.tenantUrl,
    data,
    method: 'POST',
    url: TenantServicePath.OtpVerify,
  })
}

export const SignUpFetcher = (data: SignUpRequestBodyType) =>
  fetcher({
    baseURL: env.tenantUrl,
    data,
    method: 'POST',
    url: TenantServicePath.SignUp,
  })

export const SignUpV2Fetcher = (data: SignUpV2RequestBodyType) =>
  fetcher({
    baseURL: env.tenantUrl,
    data,
    method: 'POST',
    url: TenantServicePath.SignUpV2,
  })

export const UpdateCurrentUserFetcher = (data: Partial<UpdateCurrentUserRequestBodyType>) =>
  fetcher({
    baseURL: env.tenantUrl,
    data,
    method: 'PUT',
    url: TenantServicePath.Users,
  })

export const UpdateOnboardingFetcher = (data: UpdateOnboardingRequestBodyType) =>
  fetcher({
    baseURL: env.tenantUrl,
    data,
    method: 'PUT',
    url: TenantServicePath.UpdateOnboarding,
  })

export const InviteUserFetcher = (data: InviteUserRequestBodyType) =>
  fetcher({
    baseURL: env.tenantUrl,
    data,
    method: 'POST',
    url: TenantServicePath.InviteUser,
  })

export const CreateRefreshToken = async () =>
  await fetch(`${env.tenantUrl}${TenantServicePath.RefreshToken}`, {
    method: 'POST',
    headers: {
      'x-api-key': env.APIKey,
    },
    body: JSON.stringify({
      refreshToken: localStorage.getItem('yld_r_token') as string,
    }),
  })

export const GetUserVehicles = (params: [string, string], query: string) => {
  return fetcher({
    baseURL: env.tenantUrl,
    method: 'GET',
    url: `${params?.[0]}${params?.[1]}`,
  })
}

export const UpdateCurrentTenantInvoiceFetcher = (data: UpdateCurrentTenantInvoiceRequestBodyType) =>
  fetcher({
    baseURL: env.tenantUrl,
    data,
    method: 'PUT',
    url: TenantServicePath.Invoice,
  })

export const AuthenticationCredentialFetcher = (data: AuthenticationCredentialRequestBodyType) =>
  fetcher({
    baseURL: env.tenantUrl,
    data,
    method: 'PUT',
    url: TenantServicePath.AuthenticationCredential,
  })

export const ForgotPasswordFetcher = (data: ForgotPasswordRequestBodyType) =>
  fetcher({
    baseURL: env.tenantUrl,
    data,
    method: 'POST',
    url: TenantServicePath.ForgotPassword,
  })

export const ConfirmSignUpFetcher = (data: ConfirmSignupRequestBodyType) =>
  fetcher({
    baseURL: env.tenantUrl,
    data,
    method: 'POST',
    url: TenantServicePath.ConfirmSignup,
  })

export const AuthenticationMethodFetcher = (data: AuthenticationMethodRequestBodyType) =>
  fetcher({
    baseURL: env.tenantUrl,
    data,
    method: 'PUT',
    url: TenantServicePath.AuthenticationMethod,
  })

export const ConfirmForgotPasswordFetcher = (data: ConfirmForgotPasswordRequestBody) =>
  fetcher({ baseURL: env.tenantUrl, data, method: 'POST', url: TenantServicePath.ConfirmForgotPassword })

export const ResendEmailConfirmationFetcher = (data: ResendEmailConfirmationRequestBody) =>
  fetcher({
    baseURL: env.tenantUrl,
    data,
    method: 'POST',
    url: TenantServicePath.ResendEmailConfirmation,
  })
